import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import {
  AutoComplete, Button, Form, Input,
} from 'antd';
import { Option } from '../../../../types';
import { Coin, Search } from '../../../Common/Icon';
import { SearchData, useSearch } from '../../../../hooks/api/search';

import styles from './index.module.scss';

interface SearchFormValues {
  search: string;
}

function CategoriesSearch() {
  const [form] = Form.useForm<SearchFormValues>();
  const search = useSearch();
  const navigate = useNavigate();

  const [options, setOptions] = useState<any[]>([]);
  const searchValue = Form.useWatch('search', form);
  const timeoutId = useRef<number | null>(null);

  const getSearshData = (value: string) => {
    if (!value) {
      setOptions([]);

      return;
    }

    search
      .fetch({ page: 1, pageSize: 10, search: value })
      .then((res: SearchData | null) => {
        if (res) {
          setOptions(normalizeDataForAutocomplete(res));
        }
      })
      .catch((error) => {
        console.error('Autocomplete fetch error:', error);
      });
  };

  useEffect(() => {
    if (timeoutId.current) {
      window.clearTimeout(timeoutId.current);
    }

    timeoutId.current = window.setTimeout(() => {
      getSearshData(searchValue);
    }, 1000);

    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [searchValue]);

  const onFinish = (values: SearchFormValues) => {
    if (timeoutId.current) {
      window.clearTimeout(timeoutId.current);
    }

    if (!values.search) {
      setOptions([]);

      return;
    }

    getSearshData(values.search);
  };

  return (
    <Form<SearchFormValues>
      className={styles.searchWrapper}
      onFinish={onFinish}
      form={form}
    >
      <Form.Item name="search" className={styles.searchFormItem}>
        <AutoComplete
          options={options}
          open={options.length > 0}
          onSelect={(_, option) => {
            navigate(option.url);
          }}
          className={styles.autocomplete}
        >
          <Input
            className={styles.search}
            height={66}
            placeholder="Search service or industry"
            suffix={(
              <Button
                type="text"
                className={styles.searchBtn}
                onClick={form.submit}
              >
                <Search />
              </Button>
            )}
          />
        </AutoComplete>
      </Form.Item>
    </Form>
  );
}

export default CategoriesSearch;

const normalizeDataForAutocomplete = (apiData: SearchData): any[] => {
  const groups: { label: string; options: Option[] }[] = [];

  if (apiData.categories.data.length > 0) {
    groups.push({
      label: 'Categories',
      options: apiData.categories.data.map((c) => ({
        value: c.id,
        label: c.name,
        url: `/categories/${c.id}`,
      })),
    });
  }

  if (apiData.subCategories.data.length > 0) {
    groups.push({
      label: 'Subcategories',
      options: apiData.subCategories.data.map((s) => ({
        value: s.id,
        label: s.header,
        url: `/categories/${s.category.id}/${s.id}`,
      })),
    });
  }

  return groups;
};
